import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import QuoteEditor from "@/pages/QuoteEditor";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import ChangePassword from "@/pages/ChangePassword";
import Maintenance from "@/pages/Maintenance";
import ArchivePage from "@/pages/ArchivePage";
import "@/App.css";

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="bottom-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/quote/:id" element={<Protected><QuoteEditor /></Protected>} />
          <Route path="/quote/new" element={<Protected><QuoteEditor /></Protected>} />
          <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
          <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
          <Route path="/mantenimiento" element={<Protected adminOnly><Maintenance /></Protected>} />
          <Route path="/archivo" element={<Protected><ArchivePage /></Protected>} />
          <Route path="/change-password" element={<Protected><ChangePassword /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
